module.exports = "/static/assets/f4dc047080ceaf573618136674be653a.png";